import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const PHONE = "+4746576732";
export const PHONE_LABEL = "+47 465 76 732";
export const WHATSAPP_URL = `https://wa.me/4746576732?text=${encodeURIComponent("Hei! Jeg har et spørsmål om bilen min:")}`;
export const WHATSAPP_B2B_URL = `https://wa.me/4746576732?text=${encodeURIComponent("Hei! Jeg trenger hjelp med kloning/programmering av styreenhet (ECU/TCU). Bil og delenummer:")}`;
export const COMPANY = {
  name: "RB TUN AS",
  orgnr: "935 303 036 MVA",
  address: "Jåttåveien 92, 4020 Stavanger",
  email: "info@rbtun.no",
  hours: "Man–fre 08:00–16:00",
};
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=RB+TUN+AS%2C+J%C3%A5tt%C3%A5veien+92%2C+4020+Stavanger";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CfMcjRMr7EVNEBM/review";

export const SERVICES = [
  { value: "bilnokkel", label: "Bilnøkkel / startsperre" },
  { value: "chiptuning", label: "Chiptuning" },
  { value: "kloning", label: "Kloning" },
  { value: "adblue_dpf_egr", label: "AdBlue / DPF / EGR" },
  { value: "annet", label: "Annet" },
];

export const STATUSES = [
  { value: "ny", label: "Ny" },
  { value: "kontaktet", label: "Kontaktet" },
  { value: "booket", label: "Booket" },
  { value: "fullfort", label: "Fullført" },
  { value: "avvist", label: "Avvist" },
];

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Noe gikk galt. Prøv igjen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return String(d);
}
